export default "__VITE_ASSET__QiyunAxD__"